let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ciAEf")).then(() => parcelRequire('3jWGr'));